var path = '/app/components/dialogs/help/help.html';
var html = "<div class=custom-modal-wrap ng-class=$ctrl.ruleClass> <div class=custom-modal> <div class=modal-header>Como Jogar?</div> <div class=rules ng-class=$ctrl.ruleClass> <div class=rule-box ng-repeat=\"r in $ctrl.rules\"> <p ng-bind-html=r.txt></p> <img ng-src={{r.back}} /> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/help/help.html
// module id = 151
// module chunks = 0